import { FilePen } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { useEffect, useRef, useState } from "react";
import { byteToKb } from "@/utils/conversion";

import Label from "@/components/form-controls/Label";
import Upload from "@/assets/images/upload.png"


type FileInputProps = {
    name?: string
    className?: string
    label?: string,
    labelStyle?: string,
    placeholder: string
    hasError?: boolean
    error? : string,
    multiple?: boolean
    onChange: (value: FileList) => void;
    formats?: string
    required?: boolean
    hint?: string
}


const FileInput = (props: FileInputProps) => {
    const ref = useRef(null);
    const [files, setFiles] = useState<FileList | null>(null);

    useEffect(() => {
        if(files) {
            props.onChange(files);
        }
    }, [files])

    return (
        <div className={props.className}>
            <Label 
                name={props.name ?? ""} 
                text={props.label} 
                required={props.required}
                className={props.labelStyle}
                hint={props.hint}
            />

            <div>
                <label 
                    htmlFor={props.label} 
                    onClick={() => ref.current}
                    className={twMerge(
                        "relative block w-full h-36 border border-dashed rounded-md cursor-pointer",
                        props.hasError ? "border-rose-800 bg-rose-50" : "border-primary bg-[#F2F0ED]",
                    )}
                >
                    <input
                        type="file"
                        className="hidden"
                        id={props.label}
                        placeholder={props.placeholder}
                        ref={ref}
                        multiple={props.multiple}
                        onChange={(event) => setFiles(event.target.files)}
                    />

                    <div className="absolute inset-0 flex flex-col justify-center items-center text-primary">
                        <img src={Upload} className="size-12 md:size-16 mb-3" />
                        <p className="text-xs mb-1">
                            <span className="text-primary font-medium mr-1">
                                Click or Drop
                            </span>
                            <span className="text-secondary-300">
                                here to upload
                            </span>
                        </p>
                        <p className="text-secondary-300 text-xs">
                            {props.placeholder}
                        </p>
                    </div>
                </label>

                {/* <div className="flex justify-between items-center text-[10px] text-zinc-500 py-2">
                    <p>
                       Supported {props.formats}
                    </p>

                    <p>
                        max-size
                    </p>
                </div> */}
            </div>

            {
                props.hasError &&
                <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                    {
                        props.error ?
                        props.error :
                        "field is required"
                    }
                </div>
            }

            {
                files &&
                Object.keys(files).map((fileName, index) => {
                    let file = files[index];
                    let isImageFile = file.type.split("/")[0] === "image";

                    return (
                        <section 
                            className={twMerge(
                                "w-full p-2 text-zinc-500 bg-zinc-50 border border-zinc-100 rounded"
                            )} 
                            key={fileName}
                        >
                            <div className="flex">
                                {
                                    isImageFile ?
                                    <img
                                        src={URL.createObjectURL(file)}
                                        alt={`file preview ${index}`}
                                        className="w-10 h-10 object-cover rounded-md"
                                    /> :
                                    
                                    <FilePen 
                                        className="w-10 h-10"
                                        strokeWidth={1.2}
                                    />
                                }

                                <div className="flex flex-col text-xs ml-3">
                                    <span className="font-medium">
                                        {file.name}
                                    </span>
                                    <span>{byteToKb(file.size)} KB</span>
                                </div>
                            </div>
                        </section>
                    );
                })
                
            }
            
        </div>
    )
}

export default FileInput